import { render, staticRenderFns } from "./UserScoreList.vue?vue&type=template&id=110b61bf&scoped=true&"
import script from "./UserScoreList.vue?vue&type=script&lang=js&"
export * from "./UserScoreList.vue?vue&type=script&lang=js&"
import style0 from "./UserScoreList.vue?vue&type=style&index=0&id=110b61bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110b61bf",
  null
  
)

export default component.exports